export default {
  data() {
    return {
      show: false,
      scrollEvents: []
    }
  },
  watch: {
    show() {
      if (this.show === true) {
        this.addScrollListener(this.$el);
      } else if (this.show === false) {
        this.scrollEvents.forEach((element) => {
          element.removeEventListener('scroll', this.onScroll)
        });
      }
    }
  },
  methods: {
    addScrollListener(element) {
      element.addEventListener('scroll', this.onScroll);

      this.scrollEvents.push(element);

      if (element.parentElement) {
        this.addScrollListener(element.parentElement);
      }
    },
    onScroll() {
      this.show = false;
    },
  }
}
